import { render, staticRenderFns } from "./PaymentMethodConfigModal.vue?vue&type=template&id=52d62075"
import script from "./PaymentMethodConfigModal.vue?vue&type=script&lang=js"
export * from "./PaymentMethodConfigModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodConfigModal.vue?vue&type=style&index=0&id=52d62075&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports